import * as THREE from "three";
import { Devices } from "../2D/Devices";
import { Cities } from "./Cities";
import { ColleagueSpawner } from "./ColleagueSpawner";
import { Charts } from "./Charts";

export class LevelController {

  constructor(store) {
    this.store = store;
    this.group = new THREE.Group();
    this.store.scene.add(this.group);
    this.furniture = null;
    this.devices = new Devices(this.store);
    this.store.devices = this.devices;
    this.spawner = new ColleagueSpawner(this.store, this);
    this.cities = new Cities(this.store);
    this.store.cities = this.cities;
    this.databaseUpdatedHandler = (event) => {this.databaseUpdated(event);};
    this.store.events.addEventListener("databaseUpdated", this.databaseUpdatedHandler);
    this.charts = new Charts(this.store);
     this.store.level.charts = this.charts;
  }

  async setLevel(hit) {
    //console.log('HIT ', hit.name)
    if(this.store.database.actualUser === null && this.store.level.auth){hit.name = 'AUTH'}
    let cities = null;
    if(hit !== null){
      switch (hit.name) {
        case "MAP":
          this.store.ui.showAllOffices();
          this.store.level.levelName = 'BASE'
          this.store.level.cityuser = false;
          this.store.enviroment.camera.reset();
          this.clearLevel();
          this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
          break;
        case "OFFICE":
          if(this.store.database.deviceToMove !== undefined){this.store.toast.error("Válassz kollégát!");}
          this.store.level.levelName = 'OFFICE';
          this.store.level.selectedDistrict = hit.office.district;
          this.store.level.selectedOffice = hit.office;
          await this.spawner.spawn();
          this.store.enviroment.camera.focus(hit.position);
          break;
        case "OTHEROFFICE":
          if(this.store.database.deviceToMove !== undefined){this.store.toast.error("Válassz kollégát!");}
          this.store.level.selectedDistrict = 'Tesztkörzet';
          this.store.level.selectedOffice = this.store.others;
          this.store.level.levelName = 'OTHEROFFICE';
          await this.spawner.spawn();
          this.store.enviroment.camera.focusCenter();
          break;
        case "COLLEAGUE":
            this.store.level.levelName = 'COLLEAGUE';
            this.store.modalController.setLayout({layout: "MODALOPEN", component: "DEVICES", data: null});
            this.store.enviroment.camera.reset();
            this.store.level.selectedColleague = this.store.database.users.filter(user => user.id === hit.colleague.id)[0];
          break;
        case "OFFICES":
          this.store.level.selectedOffice = hit.hit.headOffice
          this.store.level.levelName = 'OFFICES'
          this.store.enviroment.camera.reset();
          this.store.modalController.setLayout({layout: "MODALOPEN", component: "OFFICES", data: null});
          break;
        case "PLUS": this.store.modalController.setLayout({layout: "MODALOPEN", component: "__PLUS__", data: this.store.level.selectedOffice}); break;
        case "JOB_SWITCH":
          this.store.level.colleagueFilter = this.store.level.colleagueFilter === "FG" ? "HO" : "FG";
          this.spawner.spawn(this.store.colleaguesByOfficeId);
          break;
        case "SEARCH": this.store.modalController.setLayout({layout: "MODALOPEN", component: "SEARCH", data: null}); break;
        case "CSVEXPORT": this.store.modalController.setLayout({layout: "MODALOPEN", component: "SHOWEXPORT", data: null}); break;
        case "MOVE": 
          this.store.level.move = true
          this.store.toast.error("Válassz irodát!");
          if(this.store.database.deviceToMove.type === 'IT'){
            this.store.level.levelName = 'BASE'
          }else{
            this.store.level.levelName = 'MOVECITIES';
            this.setLevel({name: "MOVECITIES", hit: null})
          }
          this.store.enviroment.camera.reset(); 
          this.clearLevel();
          this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
          break;
        case "MOVECITIES":
          this.store.enviroment.camera.reset();
          this.store.level.levelName = 'MOVECITIES';
          let offices = await this.store.datas.filter('CITIES', 'appearence', 'office')
          let others = await this.store.datas.filter('CITIES', 'appearence', 'other')
          this.store.database.actualLocations = [...offices, ...others]
          this.store.cities = this.cities;
          this.cities.render()
          break;
        case "CITIES":
          this.store.enviroment.camera.reset();
          this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
          this.store.level.levelName = 'CITIES';
          this.store.cities = this.cities;
          await this.store.datas.load('CITIES');
          this.cities.render()
          break;
        case "CITYUSER": 
          this.clearLevel()
          this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
          if(this.store.level.cityCaller === 'OFFICE'){
            this.store.ui.showSelectedOffice();
          }else if(this.store.level.cityCaller === 'USER'){
            await this.store.cityUserController.onCityChange(this.store.level.selectedColleague);
          }
          break;
        case "AUTH":
          this.store.level.levelName = 'BASE'
          this.store.level.userAnimation = "ENTER";
          this.store.enviroment.camera.reset();
          this.store.modalController.setLayout({layout: "MODALAUTH", component: "AUTH", data: hit.data});
          break;
        case "CHART":
          this.store.level.levelName = 'CHART'
          this.store.enviroment.camera.reset();
          this.charts.render(this.store.level.chartArray)
          break;
        case "CHARTCITY":
          this.store.level.levelName = 'CHARTCITY';
          this.store.ui.clearOffices();
          this.store.enviroment.camera.reset();
          this.charts.render(this.store.level.chartArray)
          break;
      }
    }
  }

  clearLevel() {
    this.spawner.clear();
    if (this.store.cityList) {this.cities.clear();}
    this.store.input.clickables = this.store.input.clickables.filter(item => item.userData?.baseObject === true);
    this.charts.dispose();
    this.store.chartType = ''
}

  update(delta) {
    this.devices.update();
    this.store.level.charts?.update();
    if (this.store.cityList) {this.store.cities.update();}
    const office = this.store.level.selectedOffice;
    if (!office || !office.colleagues) return;
    const now = performance.now();
    office.colleagues.forEach(colleague => {
      if (now < colleague.startTime) return;
      const progress = Math.min((now - colleague.startTime) / colleague.animationDuration, 1);
      colleague.group.position.lerpVectors(new THREE.Vector3(0, 0, 0), colleague.targetPosition, progress);
    });
    
  }

  databaseUpdated(event) {
    const reference = event.detail.reference;
    switch (reference) {
        case "USERS":
          if (this.store.level.levelName === "OFFICE" || this.store.level.levelName === "OTHEROFFICE") {this.spawner.spawn();}
          break;
        case "INVENTORY":
          if (this.store.level.levelName === "COLLEAGUE") {this.store.modalController.setLayout({layout: "MODALOPEN", component: "DEVICES", data: null});}
          break;
        case "CITYUSERS":

            // Ide kerülhet a városi felhasználók frissítése
            break;
    }
  }

}
